import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'info-small', 'InfoSmall', [["path",{"d":"M12 9h.01"}],["path",{"d":"M11 12h1v4h1"}]]);